import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Chip from "@mui/material/Chip";
import Divider from "@mui/material/Divider";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

/** Bloco padrão das seções da tela de Configurações. */
const SettingsCard = ({ title, description, action, children, contentPadding = true }) => (
  <Paper variant="outlined" sx={{ borderRadius: 2, overflow: "hidden" }}>
    <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={2} px={2.5} py={2}>
      <Box minWidth={0}>
        <Typography variant="subtitle1" fontWeight={600}>
          {title}
        </Typography>
        {description && (
          <Typography variant="body2" color="text.secondary">
            {description}
          </Typography>
        )}
      </Box>
      {action}
    </Stack>
    {children && (
      <>
        <Divider />
        <Box p={contentPadding ? 2.5 : 0}>{children}</Box>
      </>
    )}
  </Paper>
);

/** Lista de opções em que uma está ativa (perfil, instituição, aluno). */
export const SelectableList = ({ items, getKey, getLabel, isSelected, onSelect, disabled = false }) => (
  <Stack divider={<Divider />}>
    {items.map((item) => {
      const selected = isSelected(item);
      return (
        <Stack
          key={getKey(item)}
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          spacing={2}
          px={2.5}
          py={1}
          sx={{ bgcolor: selected ? "action.selected" : undefined, minHeight: 48 }}
        >
          <Typography variant="body2" fontWeight={selected ? 600 : 400}>
            {getLabel(item)}
          </Typography>
          {selected ? (
            <Chip size="small" color="success" variant="outlined" label="Ativo" />
          ) : (
            <Button size="small" disabled={disabled} onClick={() => onSelect(item)}>
              Ativar
            </Button>
          )}
        </Stack>
      );
    })}
  </Stack>
);

export default SettingsCard;
